import { removeSubscription } from "../../Core/remove-subscription.js";
import { SUBSCRIPTION_ID_DATA_ATTRIBUTE as p } from "../../common/constants.js";
export function destroyBannerHtml(o) {
  const n = o.getAttribute(p);
  null != n && removeSubscription(n),
    o && o.parentNode && o.parentNode.removeChild(o);
}
